import Ajax from "./ajax";

// 练习中心
export const CourseList = data => Ajax.get(`/fs-practice-test-course`, data); //查询相关课程
export const TestType = data => Ajax.get(`/fs-practice-test-type`, data); //查询试卷类型
export const TestList = data => Ajax.get(`/fs-practice-test-list`, data); //查询试卷类型
export const TestInfo = data => Ajax.get(`/fs-user-question-introduction`, data); //查询试卷
export const QuestionTest = data => Ajax.get(`/fs-user-question-test-pra`, data); //获取试卷试题
export const QuestionTestKs = data => Ajax.get(`/fs-user-test-exam`, data); //获取试卷试题
export const userCourseExam = data => Ajax.get(`/fs-user-course-exam`, data); //获取考查课程考试试卷题目
export const QuestionTestMoni = data => Ajax.get(`/fs-user-question-analog`, data); //获取模拟考试试题
export const QuestionTestRd = data => Ajax.get(`v1-user-question-exam`, data); //获取认定线上考试试题
export const topicSubmit = data => Ajax.post(`/fs-user-post-submit`, data); //提交
export const studentNewExamCourseSubmit = data => Ajax.post(`/v1-adult-student-new-exam-course-submit`, data); //考查考试交卷
export const postAnswer = data => Ajax.post(`/fs-user-question-post-answer`, data); //上传答题
export const studentNewExamQuestionSAnswer = data => Ajax.post(`/v1-adult-student-new-exam-question-answer`, data); //考查考试上传答案


// 学习记录
export const learnRecord = () => Ajax.get(`/fs-user-learn-record`); //听课记录
